// React
import React from 'react';
// External
import { Link } from 'react-router-dom';
// Styles
import './styles.scss';

/**
 * @param {string} props.className - Class to be applied to the header
 * @param {string} props.style - Style to be applied to the header
 * @param {string | Object} props.to - string of the route to navigate to or the object of the route (to and params)
 */
class ButtonLink extends React.Component {
    constructor(props) {
        super(props);
        this.className = props.className
            ? `btn-primary ${this.props.className}`
            : 'btn-primary';
    }

    render() {
        return (
            <Link
                className={this.className}
                style={this.props.style}
                to={this.props.to}
            >
                <span>{this.props.children}</span>
            </Link>
        );
    }
}

export default ButtonLink;
